import { Box, List, ListItemText } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { useTranslation } from "react-i18next";
import { LegendBoxList, LegendBoxListItem } from "../../legend/LegendBoxComponents";
import { memo } from "react";

const useStyles = makeStyles((theme) => ({
  contour:{
    display: 'inline-block',
    position: 'relative',
    marginLeft: 'auto',
    marginRight: 'auto',
    width: '30px',
    height: '5px',
    '&:after': {
      position: 'absolute',
      display: 'block',
      content: "''",
      top: "22px",
      left: 0,
      width: '35px'
    }
  },
  flexList: {
    display: "flex",
    padding: 0
  },
  legendBoxIsotach: {
    '&:after': {
      top: 12,
      borderTop: '4px solid rgb(7, 206, 255)'
    }
  },
  legendBoxIsotherm: {
    '&:after': {
      top: 12,
      borderTop: '4px solid rgb(200, 40, 40)'
    }
  },
  legendBoxEqvPt: {
    '&:after': {
      top: 12,
      borderTop: '4px solid rgb(107, 121, 127)'
    }
  },
  legendBoxTTd: {
    '&:after': {
      top: 12,
      borderTop: '4px solid rgb(200,190,190)'
    }
  },
  legendBoxVws15: {
    borderBottom: '4px solid rgb(255, 0, 0)',
    width: 35,
    textAlign: "center",
    marginLeft: 10
  },
  legendBoxVws12: {
    borderBottom: '4px solid rgb(255, 255, 0)',
    width: 35,
    textAlign: "center"
  },
  legendBoxVws69: {
    borderBottom: '4px solid rgb(0, 255, 0)',
    width: 35,
    textAlign: "center"
  },
  legendText: {
    whiteSpace: "nowrap"
  }
}));

function LegendLFM() {
  const classes = useStyles();
  const {t} = useTranslation();

  return (
    <Box>
      <LegendBoxList>
        <LegendBoxListItem>
          <List className={classes.flexList}>
            <LegendBoxListItem>
              <ListItemText className={classes.legendText}>{t('Wind speed')} (kt) ({t('Contour')})</ListItemText>
            </LegendBoxListItem>
            <LegendBoxListItem className={`${classes.contour} ${classes.legendBoxIsotach}`}></LegendBoxListItem>
          </List>
        </LegendBoxListItem>
        <LegendBoxListItem>
          <List className={classes.flexList}>
            <LegendBoxListItem>
              <ListItemText className={classes.legendText}>{t('Temperature')} (°C) ({t('Contour')})</ListItemText>
            </LegendBoxListItem>
            <LegendBoxListItem className={`${classes.contour} ${classes.legendBoxIsotherm}`}></LegendBoxListItem>
          </List>
        </LegendBoxListItem>
        <LegendBoxListItem>
          <List className={classes.flexList}>
            <LegendBoxListItem>
              <ListItemText>{t('Eqv.PT')} (K)</ListItemText>
            </LegendBoxListItem>
            <LegendBoxListItem className={`${classes.contour} ${classes.legendBoxEqvPt}`}></LegendBoxListItem>
          </List>
        </LegendBoxListItem>
        <LegendBoxListItem>
          <List className={classes.flexList}>
            <LegendBoxListItem>
              <ListItemText>{t('T-Td < 3°C')}</ListItemText>
            </LegendBoxListItem>
            <LegendBoxListItem className={`${classes.contour} ${classes.legendBoxTTd}`}></LegendBoxListItem>
          </List>
        </LegendBoxListItem>
        <LegendBoxListItem>
          <List className={classes.flexList}>
            <LegendBoxListItem>
              <ListItemText className={classes.legendText}>{t('VWS')} (kt)</ListItemText>
            </LegendBoxListItem>
            <LegendBoxListItem>
              <ListItemText className={classes.legendBoxVws15}>&gt;15</ListItemText>
            </LegendBoxListItem>
            <LegendBoxListItem>
              <ListItemText className={classes.legendBoxVws12}>12</ListItemText>
            </LegendBoxListItem>
            <LegendBoxListItem>
              <ListItemText className={classes.legendBoxVws69}>6-9</ListItemText>
            </LegendBoxListItem>
          </List>
        </LegendBoxListItem>
      </LegendBoxList>
    </Box>
  )
}

export default memo(LegendLFM);
